<nz-col *ngFor="let data of paginatedLines; let j = index;" nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
  <nz-card [nzActions]="(section.AdditionalInformationParsed.AllowDelete || (section.AdditionalInformationParsed.AllowDeleteForNewLines &&
      data.IsNew)) ? [deleteAction, editAction] : [editAction]"
    class="card-line section-line-template-details" [hidden]="">
    <span [innerHTML]="data.LineTemplateHtml | safeHtml">
    </span>
    <div>
      <div class="ant-statistic">
        <div class="ant-statistic-content">
          <div class="ant-statistic-title">
            {{itemCodeField.Label | locale}}
          </div>
          <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="itemCodeField"
            [recordModel]="recordModel" [section]="section" [actionType]="actionType">
          </app-field>
          <ng-container *ngIf="countedField === undefined">
            <div class="ant-statistic-title">
              {{quantityField.Label | locale}}
            </div>
            <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="quantityField"
              [recordModel]="recordModel" [section]="section" [actionType]="actionType">
            </app-field>
          </ng-container>
          <ng-container *ngFor="let field of fieldsToRender">
            <div class="ant-statistic-title">
              {{field.Label | locale}}
            </div>
            <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="field"
              [recordModel]="recordModel" [section]="section" [actionType]="actionType">
            </app-field>
          </ng-container>
          <nz-space style="width: 100%;" *ngIf="countedField !== undefined">
            <nz-space-item>
              <div class="ant-statistic-title">
                {{quantityField.Label | locale}}
              </div>
              <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="quantityField"
                [recordModel]="recordModel" [section]="section" [actionType]="actionType">
              </app-field>
            </nz-space-item>
            <nz-space-item *ngIf="countedField !== undefined" style="text-align: center;">
              <div class="ant-statistic-title">
                {{'Counted' | locale}}
              </div>
              <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="countedField"
                [recordModel]="recordModel" [section]="section" [actionType]="actionType">
              </app-field>
            </nz-space-item>
          </nz-space>
          <nz-alert
            *ngIf="data.OpenQtyProp !== undefined && data.OpenQtyProp.ValueAsObject !== 0 && data.OpenQtyProp.ValueAsObject !== '' && data.OpenQtyProp.ValueAsObject < data.QuantityProp.ValueAsObject"
            nzType="error"
            [nzMessage]="'The selected quantity (' + data.QuantityProp.ValueAsObject + ') exceeds the open quantity: ' + data.OpenQtyProp.ValueAsObject">
          </nz-alert>
        </div>
      </div>
    </div>
    <ng-template #deleteAction>
      <a nz-popconfirm *ngIf="(section.AdditionalInformationParsed.AllowDelete || (section.AdditionalInformationParsed.AllowDeleteForNewLines &&
      data.IsNew))"
        [nzPopconfirmTitle]="'Are you sure you want to delete this row?'| locale" nzPopconfirmPlacement="bottomLeft"
        (nzOnConfirm)="deleteRow(data.Id)">
        <i nz-icon nzType="delete" nzTheme="outline"></i> {{ 'Delete' | locale }}
      </a>
    </ng-template>
    <ng-template #editAction>
      <a (click)="editRow(data, true)">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i> {{ 'Details' | locale }}
      </a>
    </ng-template>
    <ng-container *ngIf="data.IsEditModeDrawerInitialized">
      <nz-drawer nzWrapClassName="drawer-size-3x" [nzVisible]="data.IsEditMode" nzClosable="true"
        (nzOnClose)="editRow(data, false);" [nzTitle]="('Row Details' | locale) + ' #' + (j + 1)"
        [nzFooter]="drawerFooter">
        <div nz-row *ngIf="data.IsEditMode">
          <div nz-col nzXs="24" nzSm="24" nzMd="24"
            [nzLg]="{ span: getSpanVal(fieldKey), push: getPushVal(fieldKey), pull: getPullVal(fieldKey) }"
            [nzXl]="{ span: getSpanVal(fieldKey), push: getPushVal(fieldKey), pull: getPullVal(fieldKey) }"
            *ngFor="let fieldKey of fieldGroupKeys">
            <div *ngFor="let field of fieldGroups[fieldKey]">
              <app-field [moduleStructure]="moduleStructure" [field]="field" [recordModel]="recordModel"
                [section]="section" [lineId]="data.Id" forceLabelVisible="true" [actionType]="actionType">
              </app-field>
            </div>
          </div>
        </div>
      </nz-drawer>
    </ng-container>
    <ng-template #drawerFooter>
      <button nz-button nzType="primary" (click)="data.IsEditMode = false">
        {{'OK' | locale}}
      </button>
    </ng-template>
  </nz-card>
</nz-col>
<nz-row>
  <div [hidden]="!enablePaginationInLineSection">
    <nz-pagination [(nzPageIndex)]="currentPage" [nzTotal]="lines.length" [nzPageSize]="pageSizeInLineSection"
      (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>
</nz-row>
